import React from "react";

import { FooterBase } from "../common/footer-base";
import { FooterBaseSection } from "../footer-base-section";

export const FunnelFooter: React.FC = () => {
  return (
    <FooterBaseSection>
      <FooterBase variant="default" />
    </FooterBaseSection>
  );
};
